'use client';

import { useMemo } from 'react';
import Image from '@src/components/atoms/safe-image';

// Components
import ListProperty from '@src/components/molecules/shared/list-property';

// Context
import useOnlineProfileCtx from '@src/context/online-profile-ctx';

import EmptyState from '@public/png/empty-listing-online-profile.png';

const ListPropertyOrganism = () => {
  const {
    listListing,
    fetchNextPageListListing,
    hasNextPageListListing,
    isLoadingListListing,
    isFetchingNextPageListListing,
    username,
  } = useOnlineProfileCtx();

  const data = useMemo(() => {
    if (!listListing?.pages?.length) return [];

    return listListing.pages.flatMap((d) => d?.data?.data ?? []);
  }, [listListing]);

  if (
    !data?.length &&
    !isLoadingListListing &&
    !isFetchingNextPageListListing
  ) {
    return (
      <div className="flex flex-col items-center justify-center gap-4 h-[944px]">
        <Image src={EmptyState} alt="Empty state" width={200} height={200} />
        <p className="text-[21px] font-satoshi-bold text-[#252526]">
          Belum ada properti di area ini
        </p>
        <p className="text-[14px] font-satoshi text-[#686A68] max-w-[438px] text-center">
          Coba perluas area pencarian Anda atau gunakan filter lain untuk
          menemukan pilihan properti yang sesuai.
        </p>
      </div>
    );
  }

  return (
    <ListProperty
      data={data}
      isFetchingNextPage={isFetchingNextPageListListing}
      hasNextPage={hasNextPageListListing}
      isLoading={isLoadingListListing}
      fetchNextPage={fetchNextPageListListing}
      mutateSubmit={() => {}}
      kind="ONE21 Portal"
      showButtonHubungkan={false}
      showUserName={false}
      showCompany={false}
      showUserInfo={false}
      idMarketing={username}
    />
  );
};

export default ListPropertyOrganism;
